import { StyleSheet } from 'react-native';
import colors from '@/config/colors';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  cardStyle: {
    maxWidth: 1500,
    alignSelf: 'center',
    width: '80%',
  },
  centeredView: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#00000099',
  },
  underline: {
    width: '100%',
    height: 1,
    marginBottom: 10,
    backgroundColor: colors.grey,
  },
  modalView: {
    backgroundColor: 'white',
    padding: theme.spacings.sm,
    alignItems: 'center',
    maxWidth: 500,
    marginHorizontal: 10,
  },
  modalButton: {
    color: colors.white,
    fontWeight: '700',
    textAlign: 'center',
  },
  modalTitle: {
    marginBottom: theme.spacings.sm,
    textAlign: 'center',
    opacity: 0.5,
    fontWeight: '700',
  },
  modalText: {
    marginBottom: theme.spacings.md,
    fontSize: theme.fontSizes.xl,
  },
  button: {
    width: '100%',
    padding: theme.spacings.sm,
    backgroundColor: colors.darkPurpleBlue,
    borderColor: 'transparent',
  },
  formFieldTwoThirds: {
    width: '66%',
  },
  fieldLabel: {
    fontSize: theme.fontSizes.base,
    fontWeight: '600',
    fontFamily: 'InterSemiBold',
    color: colors.newUI.therapist.textBlue100,
    marginBottom: theme.spacings.sm,
  },
  link: {
    color: colors.link,
    textDecorationLine: 'underline',
  },
  fieldInfo: {
    fontSize: theme.fontSizes.sm,
    fontWeight: '400',
    color: colors.newUI.therapist.textBlue100,
    marginBottom: theme.spacings.sm,
  },
  footer: {
    maxWidth: 1500,
    width: '80%',
    alignSelf: 'center',
    gap: theme.spacings.md,
    paddingVertical: theme.spacings.lg,
  },
  footerButtons: {
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  section: {
    paddingVertical: theme.spacings.lg,
    paddingHorizontal: theme.spacings.xl,
  },
  nameRow: {
    flexDirection: 'row',
    gap: 16,
    maxWidth: '90%',
  },
});
